<div class="filters__row first">
  <div class="filters__popular">
    <label>{{'Popular' | transloco}}:</label>
    <span (click)="setLevel(1, 'Olympics')" [ngClass]="(isLevel(1) | async) === true ? 'checked' : 'unchecked'">{{'Olympics' | transloco}}</span>
    <span (click)="setLevel(2, 'World Championships')" [ngClass]="(isLevel(2) | async) === true ? 'checked' : 'unchecked'">{{'world_championships' | transloco}}</span>
    <span (click)="setLevel(3, 'World cup')" [ngClass]="(isLevel(3) | async) === true ? 'checked' : 'unchecked'">{{'world_cup' | transloco}}</span>
  </div>
</div>
<lib-filters-component [filters_options]="filter_service.filtersType">

</lib-filters-component>
